import React from 'react';

import { useIntl } from 'react-intl-next';

import CloseDateFilterWithDatePicker from '../../../../../common/ui/filters/close-date-filter';
import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import {
	useFiltersDiscoverability2Enabled,
	usePrimaryProduct,
} from '../../../../../controllers/store/bootstrap';
import { filter as closeDateFilter } from '../../../../../controllers/store/search/filters/close-date';

import { i18n } from './messages';

const CloseDateFilter = ({
	testId = 'salesforce-close-date-filter',
	isFilterInDropdown,
	showPrimaryProductIcon,
	fit = 'default',
	onFilterChange,
	hideOnHoverOut,
}: {
	testId?: string;
} & FilterProps): React.JSX.Element | null => {
	const [primaryProduct] = usePrimaryProduct();
	const { formatMessage } = useIntl();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();

	const [filterData, { setOption, loadInitialOptions }] = useSelectFilter({
		filterId: closeDateFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { options, selectedOptions, customValue } = filterData;

	const label =
		fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage(i18n.closeDate);

	return (
		<CloseDateFilterWithDatePicker
			contentFit={fit}
			options={options}
			onSelectChange={(option, ...restArgs) => {
				setOption(option, ...restArgs);
				onFilterChange?.(option);
			}}
			label={label}
			onDropdownOpen={loadInitialOptions}
			selectedOptions={selectedOptions}
			customDateValue={customValue?.closeDateVal || ''}
			testId={testId}
			isFilterInDropdown={isFilterInDropdown}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
			iconBefore={
				<FilterProductIcon
					showPrimaryProductIcon={showPrimaryProductIcon}
					primaryProduct={primaryProduct}
				/>
			}
			hideOnHoverOut={hideOnHoverOut}
		/>
	);
};

export default CloseDateFilter;
